import { render, staticRenderFns } from "./EditPopUp.vue?vue&type=template&id=25b1aa6e"
import script from "./EditPopUp.vue?vue&type=script&lang=js"
export * from "./EditPopUp.vue?vue&type=script&lang=js"
import style0 from "./EditPopUp.vue?vue&type=style&index=0&id=25b1aa6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports